/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

const mock = [
  {
    
    description:
      'Science Association 6 to 8',
    href : '/science-association-6-8-2025'
 
  },
   {
    
    description:
      'EVS CCA Class 2',
    href : '/animal-world-2025'
 
  },
   {
    
    description:
      'National Space Day',
    href : '/national-space-day-2025'
 
  },
  {
    
    description:
      'Senior Science Association',
    href : '/senior-science-association'
 
  },
   {
    
    description:
      'General Science CCA',
    href : '/general-science-cca-2025'
 
  },
  {
    
    description:
      'EVS CCA Class 1',
    href : '/balanced-diet-2025'
 
  }
]

const Sidebar2025 = () => {
  
  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
        Science Association 2025-26
      </Typography>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button href = {item.href}>
                <Typography component={'h6'}>
                  {item.description}
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Sidebar2025;
